/**
 * Rebuy bundle quick view — extends theme <quick-view> with bundle-specific modal content.
 * Collection pages still use the native theme.js QuickView unchanged.
 */
customElements.whenDefined('quick-view').then(function () {
  var ThemeQuickView = customElements.get('quick-view');
  var WIDGET_ID = '296153';

  // Blocks removed from the Rebuy bundle quick view only (collection modal unchanged).
  var REMOVABLE_BLOCK_SELECTORS = [
    'pickup-availability',
    '.complementary-products',
    'product-complementary',
    '.product-countdown',
    '.product-form__alert'
  ];

  // Shop Pay / dynamic checkout — below reviews and next to ATC.
  var SHOP_PAY_SELECTORS = [
    '.shopify-payment-button',
    'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-cart',
    'shopify-payment-terms',
    'form.installment',
    'form[id^="ProductFormInstallment-"]'
  ];

  // "View full details" sticky link at the bottom of the modal.
  var VIEW_FULL_DETAILS_SELECTORS = [
    'a.product__more',
    '.product__more'
  ];

  function getBundleWidget() {
    if (typeof window.sunNinjaGetBundleWidget === 'function') {
      return window.sunNinjaGetBundleWidget();
    }

    if (window.Rebuy && Array.isArray(Rebuy.widgets)) {
      return Rebuy.widgets.find(function (widget) {
        return String(widget.id) === WIDGET_ID;
      }) || null;
    }

    return null;
  }

  function getWidgetSteps(widget) {
    if (!widget || !widget.data) {
      return [];
    }

    if (widget.data.config && Array.isArray(widget.data.config.steps)) {
      return widget.data.config.steps;
    }

    if (Array.isArray(widget.data.steps)) {
      return widget.data.steps;
    }

    return [];
  }

  function findProductInStep(step, productId) {
    if (!step || !Array.isArray(step.products)) {
      return null;
    }

    return step.products.find(function (item) {
      return String(item.id) === String(productId);
    }) || null;
  }

  function getBundleContext(modalElement) {
    var widget = getBundleWidget();
    var productId =
      modalElement.getAttribute('data-rebuy-product-id') ||
      modalElement.dataset.rebuyProductId;
    var stepIndex = parseInt(
      modalElement.getAttribute('data-rebuy-step-index') ||
        modalElement.dataset.rebuyStepIndex,
      10
    );
    var steps = getWidgetSteps(widget);

    if (!widget || !steps.length || productId == null) {
      return null;
    }

    if (!isNaN(stepIndex)) {
      var step = steps[stepIndex];
      var product = findProductInStep(step, productId);

      if (product) {
        return {
          widget: widget,
          product: product,
          step: step,
          stepIndex: stepIndex
        };
      }
    }

    for (var i = 0; i < steps.length; i++) {
      var fallbackProduct = findProductInStep(steps[i], productId);

      if (fallbackProduct) {
        return {
          widget: widget,
          product: fallbackProduct,
          step: steps[i],
          stepIndex: i
        };
      }
    }

    return null;
  }

  function getAddToBundleLabel(widget, step) {
    if (widget && typeof widget.getBundleConfigLabel === 'function') {
      var label = widget.getBundleConfigLabel('add_to_bundle', step);
      if (label) {
        return label;
      }
    }

    return 'Add to Bundle';
  }

  function getSoldOutLabel(widget) {
    if (widget && typeof widget.getBundleConfigLabel === 'function') {
      var label = widget.getBundleConfigLabel('sold_out');
      if (label) {
        return label;
      }
    }

    return 'Sold out';
  }

  function syncSelectedVariant(context, variantId) {
    if (!context || !variantId) {
      return;
    }

    context.product.selected_variant_id = parseInt(variantId, 10);

    if (typeof context.widget.selectVariant === 'function') {
      context.widget.selectVariant(context.product);
    }
  }

  function updateAddToBundleButton(button, context, variant) {
    if (!button || !context) {
      return;
    }

    var textNode = button.querySelector('.btn-text');
    var widget = context.widget;
    var product = context.product;
    var available = variant ? variant.available : widget.variantAvailable(product.selected_variant);
    var disabled = false;

    if (typeof widget.shouldDisableProductAddToBundle === 'function') {
      disabled = widget.shouldDisableProductAddToBundle(product, context.step, context.stepIndex);
    }

    if (!available) {
      button.disabled = true;
      if (textNode) {
        textNode.textContent = getSoldOutLabel(widget);
      }
      return;
    }

    button.disabled = disabled;
    if (textNode) {
      textNode.textContent = getAddToBundleLabel(widget, context.step);
    }
  }

  function removeNodes(drawerContent, selectors) {
    selectors.forEach(function (selector) {
      drawerContent.querySelectorAll(selector).forEach(function (node) {
        node.remove();
      });
    });
  }

  function removeShopPayBlocks(drawerContent) {
    removeNodes(drawerContent, SHOP_PAY_SELECTORS);
  }

  function removeViewFullDetailsLink(drawerContent) {
    removeNodes(drawerContent, VIEW_FULL_DETAILS_SELECTORS);

    drawerContent.querySelectorAll('.product__info.with-read-more').forEach(function (node) {
      node.classList.remove('with-read-more');
    });
  }

  function removeModalBlocks(drawerContent) {
    removeNodes(drawerContent, REMOVABLE_BLOCK_SELECTORS);
    removeShopPayBlocks(drawerContent);
    removeViewFullDetailsLink(drawerContent);
  }

  // Shop Pay widgets can inject asynchronously after scripts run.
  function scheduleShopPayCleanup(drawerContent) {
    removeShopPayBlocks(drawerContent);
    window.setTimeout(function () {
      removeShopPayBlocks(drawerContent);
    }, 100);
    window.setTimeout(function () {
      removeShopPayBlocks(drawerContent);
    }, 500);
  }

  function styleAddToBundleButton(button) {
    button.classList.add('rebuy-button', 'rebuy-bundle-modal__add-button');
    button.classList.remove('button--primary');

    var btnFill = button.querySelector('.btn-fill');
    if (btnFill) {
      btnFill.remove();
    }
  }

  function wireAddToBundleButton(modalElement, drawerContent, context) {
    var productForm = drawerContent.querySelector('form.product-form, form[is="product-form"]');
    var submitButton = drawerContent.querySelector('.product-form__submit');

    if (!productForm || !submitButton) {
      return;
    }

    submitButton.type = 'button';
    submitButton.removeAttribute('name');
    styleAddToBundleButton(submitButton);
    updateAddToBundleButton(submitButton, context, null);

    productForm.addEventListener('submit', function (event) {
      event.preventDefault();
    });

    submitButton.addEventListener('click', function () {
      if (submitButton.disabled) {
        return;
      }

      var variantInput = productForm.querySelector('input[name="id"]');
      var variantId = variantInput && variantInput.value;

      syncSelectedVariant(context, variantId);

      if (!context.widget.variantAvailable(context.product.selected_variant)) {
        updateAddToBundleButton(submitButton, context, null);
        return;
      }

      context.widget.addProductToBundle(context.product, context.step, context.stepIndex);
      modalElement.hide();
    });

    productForm.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;

      if (variant && variant.id) {
        syncSelectedVariant(context, variant.id);
      }

      updateAddToBundleButton(submitButton, context, variant);
    });
  }

  class RebuyQuickView extends ThemeQuickView {
    customizeModalContent(drawerContent) {
      removeModalBlocks(drawerContent);
      scheduleShopPayCleanup(drawerContent);

      var context = getBundleContext(this);

      if (context) {
        wireAddToBundleButton(this, drawerContent, context);
      }
    }

    quickview() {
      const drawerContent = this.querySelector(this.selector);
      const productUrl = this.getAttribute('data-product-url').split('?')[0];
      const sectionUrl = `${productUrl}?view=modal`;

      fetch(sectionUrl)
        .then(response => response.text())
        .then(responseText => {
          setTimeout(() => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = parsedHTML.querySelector(this.selector);

            if (!productElement) {
              console.error('[rebuy-quick-view] Could not find modal content in response');
              return;
            }

            this.setInnerHTML(drawerContent, productElement.innerHTML);
            this.customizeModalContent(drawerContent);
            theme.a11y.trapFocus(this, this.focusElement);

            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productUrl: this.getAttribute('data-product-url'),
                source: 'rebuy-bundle'
              }
            }));
          }, 200);
        })
        .catch(e => {
          console.error(e);
        });
    }

    setInnerHTML(element, innerHTML) {
      element.innerHTML = innerHTML;

      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }
  }

  customElements.define('rebuy-quick-view', RebuyQuickView);
});
